import React from "react";
import { Button } from "@mui/material";
// import Checkbox from "@mui/material/Checkbox";
import "./quoteCard.css";
import moment from "moment";
import { basename } from '../../../../../../config'

function RequestQuoteCard({
  item,
  comLogo,
  compName,
  cutoffdate,
  index,
  onRequestQuote,
  origindate,
  destinationdate,
  setShowSchedule,
  cut
}) {
  // const [checked, setChecked] = React.useState(false);
  const data = {
    vesselName: "",
    voyage: "",
    originDate: origindate,
    destinationDate: destinationdate,
    cutoffDate: cut,
    carrier: { OrgCode: compName[index] }
  };

  return (
    <>
      <div className="scheduleSearchcardbodyCommon mb-2 pb-2">
        <div className="scheduleSearchcardbodyInner">
          <div className="scheduleSearchcardInner compdetails ps-0">
            <img src={comLogo[index]} alt="company logo" />
            <span>{compName[index]}</span>
          </div>
          <div className="scheduleSearchcardInner commondetails">
            <span>TRANSIT DAYS</span>
            <p>{item.transitTime} Days</p>
          </div>
          <div className="scheduleSearchcardInner commondetails">
            <span>ETA</span>
            <p>{cutoffdate}</p>
          </div>
          <div className="scheduleSearchcardInner requestQuote">
            {/* <Checkbox
              checked={checked}
              onChange={(e) => setChecked(e.target.checked)}
            /> */}
            <div className="_solidButton">
              <button
                onClick={() => {
                  onRequestQuote(
                    item,
                    comLogo[index],
                    compName[index],
                    cutoffdate,
                    data
                  );
                }}
              >
                Select Schedule
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="scheduleSearchcardbodyItterarte">
        {item?.transShipments?.map((transShipments, index) => {
          let etdDate = new Date(0);
          etdDate.setUTCSeconds(transShipments.departure.date);
          const etd = moment(etdDate).format("MM/DD/YYYY");
          let etaDate = new Date(0);
          etaDate.setUTCSeconds(transShipments.arrival.date);
          const eta = moment(etaDate).format("MM/DD/YYYY");

          data.vesselName = item?.transShipments[0]?.vesselName ?? "";
          data.voyage = item?.transShipments[0]?.voyage ?? "";
          return (
            <div className="scheduleSearchcardbodyInner">
              <div className="scheduleSearchcardInner commondetails ps-0">
                <span>Vessel</span>
                <p title={transShipments.vesselName}>
                  {!transShipments.vesselName &&
                    transShipments.vesselName === null
                    ? "N/A"
                    : transShipments.vesselName}
                </p>
              </div>
              <div className="scheduleSearchcardInner commondetails">
                <span>Service</span>
                <p title={transShipments.service}>
                  {!transShipments.service && transShipments.service === null
                    ? "N/A"
                    : transShipments.service}
                </p>
              </div>
              <div className="scheduleSearchcardInner commondetails">
                <span>ETD</span>
                <p>{!etd && etd !== null ? "N/A" : etd}</p>
              </div>
              <div className="scheduleSearchcardInner commondetails">
                <span>ETA</span>
                <p>{!eta && eta !== null ? "N/A" : eta}</p>
              </div>
              <div className="scheduleSearchcardInner milecol">
                <div className="searchshptimelineBody">
                  <span>ORIGIN</span>
                  <div className="searchshptimelinecontainer">
                    <span>
                      <img
                        src={`/${basename}/Assets/Images/PlaceDot.png`}
                        alt="placeDot"
                      />
                    </span>
                    <span>
                      <img
                        src={`/${basename}/Assets/Images/PlaceDot.png`}
                        alt="placeDot"
                      />
                    </span>
                    <img
                      className="dottedline"
                      src={`/${basename}/Assets/Images/Line.png`}
                      alt="line"
                    />
                  </div>
                  <span>DESTINATION</span>
                </div>
                <p>
                  <span title={transShipments.departure.portName}>
                    {transShipments.departure.portName}
                  </span>
                  <span title={transShipments.arrival.portName}>
                    {transShipments.arrival.portName}
                  </span>
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}

export default RequestQuoteCard;
